<template lang="pug">
div
  ods-sub-header(
    :is-absolute='false'
    :stretch='false').actionsCupons
    div(v-if="linkTo").actionsLeft
      router-link( :to="{ name: linkTo }")
        ods-button(type="text" icon="ods-icon-arrow-left" :loading="analyticsBussy")
      p.glue {{ title }}
    div(v-else).actionsLeft
      p {{ title }}
    div.actionsRight
      div
        ods-select(v-model="dropText" @change="onDropDownClick")
          ods-option(
            v-for="item in optionsMenu"
            :key="item.value"
            :label="item.label"
            :value="item.value")
      div
        ods-date-picker(
          v-model='valueRange'
          firstDayOfWeek=1
          format='dd/MM/yyyy'
          type='daterange'
          :start-placeholder="$t('el.datepicker.startDate')"
          :end-placeholder="$t('el.datepicker.endDate')"
          :picker-options='pickerOptions'
          @change="selectDateRange")
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LoyaltyDropDownAnalytics',
  props: ['title', 'linkTo'],
  data: () => {
    return {
      optionsMenu: [],
      dropText: null,
      dropDescr: null,
      config: '',
      hoy: new Date(),
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        onPick (value) {
          // console.log('pick', value)
        },
        shortcuts: [{
          text: 'Últimos 7 días',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 518400000)
            this.valueRange = [start, end]
          }
        }]
      },
      valueRange: ''
    }
  },
  computed: {
    ...mapGetters({
      loading: 'getDropMenuState',
      loadingOptionMenu: 'getLoadingOptionMenu',
      getCadena: 'getlistCommercialData',
      getLang: 'getLang',
      analyticsBussy: 'analyticsBussy'
    })
  },
  methods: {
    ...mapActions(['getListPrograms', 'updateDropDown', 'getConfig', 'updateDateTo']),
    onDropDownClick (event) {
      sessionStorage.setItem('appProgram', event)
      for (let step = 0; step <= this.optionsMenu.length - 1; step++) {
        if (this.optionsMenu[step].value === sessionStorage.getItem('appProgram')) {
          sessionStorage.setItem('appProgramDescr', this.optionsMenu[step].label)
        }
      }
      this.updateDropDown(event)
    },
    convertSelectioData (data) {
      const filteredData = Object.values(data.reduce((acc, cur) => Object.assign(acc, { [cur.codprogr]: cur }), {}))
      const options = []
      for (const i in filteredData) {
        options.push({ label: filteredData[i].desccpro, value: filteredData[i].codprogr })
      }
      return options
    },
    getParamsRole () {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      this.role = storageAppData.customer_role
      const params = { holding: '', codcadena: '', codcom: '' }
      if (this.role === '01') {
        const holding = this.$store.getters.getListHoldingData
        params.holding = holding[0].holding
      }
      if (this.role === '02') {
        const codcadena = this.getCadena
        params.codcadena = codcadena[0].codcadenal
      }
      if (this.role === '03') {
        const codcadena = this.$store.getters.getlistCommercialData
        params.codcom = codcadena[0].codcom
      }
      sessionStorage.setItem('customerRole', JSON.stringify(params))
      return params
    },
    async getData (data) {
      if (sessionStorage.getItem('appProgram') === null || sessionStorage.getItem('listProgram') === null) {
        const response = await this.getListPrograms(data)
        if (response.registros) {
          response.registros = Array.isArray(response.registros) ? response.registros : [response.registros]
          this.optionsMenu = this.convertSelectioData(response.registros)
          sessionStorage.setItem('listProgram', JSON.stringify(this.optionsMenu))
          this.dropText = this.optionsMenu[0].value
          this.dropDescr = this.optionsMenu[0].label
          this.updateDropDown(this.dropText)
          sessionStorage.setItem('appProgram', this.dropText)
          sessionStorage.setItem('appProgramDescr', this.dropDescr)
        }
      } else {
        this.$store.commit('LOADING_DROP_MENU_FINISHED', true)
        const getProgram = sessionStorage.getItem('appProgram')
        const getListProgram = JSON.parse(sessionStorage.getItem('listProgram'))
        this.dropText = getProgram
        this.optionsMenu = getListProgram
      }
    },
    selectDateRange () {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      const lang = this.getLang.toUpperCase()
      if (this.valueRange) {
        if ((this.valueRange[1].getTime() - this.valueRange[0].getTime()) !== 518400000) {
          this.$notify({
            title: this.$t('loyalty.analytics.lastWeek'),
            message: this.$t('loyalty.analytics.lastWeekWarning', { startDate: this.valueRange[0].toLocaleString(lang, options), endDate: this.valueRange[1].toLocaleString(lang, options) }),
            type: 'warning',
            offset: 50,
            duration: 8000
          })
          this.valueRange[1].setTime(this.valueRange[1].getTime())
          this.valueRange[0].setTime(this.valueRange[1].getTime() - 518400000)
        }
        const isoDate = this.valueRange[1]
        isoDate.setTime(isoDate.getTime() - isoDate.getTimezoneOffset() * 60000)
        sessionStorage.setItem('loyaltyAnalyticsDateTo', isoDate.toISOString().split('T')[0])
        // sessionStorage.setItem('loyaltyAnalyticsFechaHasta', isoDate.toISOString().split('T')[0])
        this.updateDateTo(isoDate.toISOString().split('T')[0])
        // console.log('date', this.valueRange[1])
      }
    }
  },
  watch: {
    async loadingOptionMenu (data, oldData) {
      const params = JSON.parse(sessionStorage.getItem('customerRole')) === null ? this.getParamsRole() : JSON.parse(sessionStorage.getItem('customerRole'))
      if (!data) {
        this.getData(params)
      }
    },
    getLang () {
      this.pickerOptions.shortcuts[0].text = this.$t('loyalty.analytics.lastWeek')
    }
  },
  async mounted () {
    const userDate = sessionStorage.getItem('loyaltyAnalyticsDateTo')
    this.pickerOptions.shortcuts[0].text = this.$t('loyalty.analytics.lastWeek')
    if (userDate) {
      this.hoy = new Date(userDate)
    } else {
      this.hoy = new Date()
    }
    const start = new Date()
    // start.setTime(this.hoy.getTime() - 3600 * 1000 * 24 * 6)
    start.setTime(this.hoy.getTime() - 518400000)
    this.valueRange = [start, this.hoy]
    this.selectDateRange()

    const params = JSON.parse(sessionStorage.getItem('customerRole')) === null ? this.getParamsRole() : JSON.parse(sessionStorage.getItem('customerRole'))
    if (!this.loadingOptionMenu) {
      this.getData(params)
    }
  }
}
</script>
